import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

export const LoadingMainPanelSection = ({
  hasHeader,
}: {
  hasHeader?: boolean;
}) => {
  return (
    <>
      {hasHeader ? <div css={loadingHeaderStyles}></div> : null}
      <div css={loadingSectionStyles}></div>
    </>
  );
};

const loadingHeaderStyles = css({
  height: '35px',
  width: '45%',
  background: token('color.background.accent.gray.subtlest'),
  borderRadius: '8px',
});

const loadingSectionStyles = css({
  height: '154px',
  width: '100%',
  background: token('color.background.accent.gray.subtlest'),
  borderRadius: '8px',
});
